@if (projectPositionsFilled && (projectDetails?.status == 'STARTED' || projectDetails?.status == 'PUBLISHED')) {
    <div class="flex flex-column xl:flex-row lg:flex-row gap-2 lg:gap-0 xl:gap-0 justify-content-end">
        @if(!user.firm.isDocusignEnabled){
            <p-button (click)="downloadDocuments()" [rounded]="true"  label="download documents"  class="flex primary-background primary white-space-nowrap send-message-color">
                <span class="{{helperService.getEnvironmentName()}}-icon icon-download-outlined white"></span>
            </p-button>
        }
        <p-button (click)="openGroupChat()" [rounded]="true" label="send group message" class="ml-0 xl:ml-3 lg:ml-3 flex primary-background primary white-space-nowrap send-message-color">
            <span class="{{helperService.getEnvironmentName()}}-icon icon-forum-outlined white"></span>
        </p-button>
        <p-button (click)="showMailDialog(projectDetails._id, emailType.project, projectDetails.firm, 'All Staff', '', '')" [rounded]="true" label="send group email" class="ml-0 xl:ml-3 lg:ml-3 flex primary-background primary white-space-nowrap send-message-color">
            <span class="{{helperService.getEnvironmentName()}}-icon icon-mail-outlined white"></span>
        </p-button>
    </div>
    <div class="table-options align-items-end justify-content-end"></div>
}

@if (projectStaffList.length) {
    <p-table styleClass="p-datatable-sm p-datatable-sm--normal mt-6" [value]="projectStaffList" dataKey="_id" [tableStyle]="{ 'min-width': '60rem' }"
    [expandedRowKeys]="expandedRows" (onRowExpand)="onRowExpand($event)"
    (onRowCollapse)="onRowCollapse($event)"
    autoLayout="true" [scrollable]="true"
    >
        <ng-template pTemplate="header">
            <tr>
                <th>
                    Role
                </th>
                <th>
                    Position
                </th>
                <th>
                    {{'Start Date' | sentenceCase}}
                </th>
                @if (helperService.checkResponsive()) {
                    <th style="width: 8%" alignFrozen="right" pFrozenColumn>
                      <ng-container *ngTemplateOutlet="frozenHeader"></ng-container>
                    </th>
                    } @else {
                    <th style="width: 20%">
                      <ng-container *ngTemplateOutlet="frozenHeader"></ng-container>
                    </th>
                }
                <ng-template #frozenHeader>
                Actions
                </ng-template>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" class="border-0 bg-gray-50" let-projectStaffList let-expanded="expanded">
            <tr>
                <td class="left-border">
                    <div class="wrap-check-data flex align-items-center gap-3 font-bold">
                        {{ projectStaffList.roleType }}
                    </div>
                </td>
                <td>
                    {{ projectStaffList.positions || 0}} listed / 
                    {{ projectStaffList.positionsFilled || 0 }} filled 
                </td>
                <td>{{ projectStaffList.startAt | date : 'MM/dd/yyyy' }}</td>
                @if (helperService.checkResponsive()) {
                    <td alignFrozen="right" pFrozenColumn>
                      <ng-container *ngTemplateOutlet="frozenData"></ng-container>
                    </td>
                  } @else {
                    <td>
                      <ng-container *ngTemplateOutlet="frozenData"></ng-container>
                    </td>
                  } 
                 <ng-template #frozenData>
                     <div class="wrap-actions flex gap-2 w-fit">
                         @if(projectStaffList.status === roleStatus.active){
                             <div  [pTooltip]="'End Role' | sentenceCase" tooltipPosition="top">
                                 <p-button (click)="openDeleteModal(projectStaffList)" [rounded]="true" [text]="true" icon="true" plain="true">
                                     <span class="{{helperService.getEnvironmentName()}}-icon icon-delete-outlined red"></span>
                                 </p-button>
                             </div>
                         }
                         @if(projectStaffList.status !== roleStatus.archive){
                             <p-button [disabled]="!projectStaffList.positionsList || !projectStaffList.positionsList.length" [pTooltip]="'Email Role' | sentenceCase" 
                             tooltipPosition="top" [rounded]="true" (click)="showMailDialog(projectDetails._id, emailType.role, projectDetails.firm, projectStaffList.roleType, projectStaffList._id, '')" [text]="true" icon="true">
                                     <span class="{{helperService.getEnvironmentName()}}-icon icon-mail-outlined"></span>
                             </p-button>
                             <p-button [disabled]="!projectStaffList.positionsList || !projectStaffList.positionsList.length" [pTooltip]="'Message Role test' | sentenceCase" 
                             tooltipPosition="top" (click)="openCreateChat(projectStaffList)" [rounded]="true" [text]="true" icon="true">
                                 <span class="{{helperService.getEnvironmentName()}}-icon icon-forum-outlined"></span>
                             </p-button>
                         }
                         @if(projectStaffList.status === roleStatus.archive){
                             <div>
                                 <span class="tag-value {{ 'ARCHIVE' | lowercase }}">
                                     Ended
                                 </span>
                             </div>
                         }
                         <p-button [ngStyle]="{'margin-left': helperService.checkResponsive() ? '10px' : 'auto'}" [pTooltip]="expanded? 'Close' : 'Expand'" 
                         tooltipPosition="top" type="button" pRipple [pRowToggler]="projectStaffList" [text]="true"
                             [rounded]="true" [plain]="true" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-up'" 
                             [size]="'large'" class="row-toggler" />
                         <!-- Filter button per role -->
                         <p-button
                             pTooltip="Filter staff" tooltipPosition="top"
                             [rounded]="true" [text]="true"
                             [icon]="'pi pi-filter' + (isFilterActive(projectStaffList._id) ? '-fill' : '')"
                             [ngClass]="{'text-primary-500': isFilterActive(projectStaffList._id)}"
                             (click)="openStaffFilterPanel(projectStaffList, $event)"
                             [badge]="getActiveFilterCount(projectStaffList._id) > 0 ? getActiveFilterCount(projectStaffList._id).toString() : ''"
                             badgeSeverity="danger">
                         </p-button>
                     </div>
                 </ng-template>
            </tr>
        </ng-template>
    
        <ng-template pTemplate="rowexpansion" let-projectStaffList>
            @if(projectStaffList.positionsList && projectStaffList.positionsList.length > 0){
                <tr>
                    <td colspan="7" class="p-0">
                        <!-- Filter chips bar -->
                        @if(isFilterActive(projectStaffList._id)){
                            <div class="flex align-items-center flex-wrap gap-2 px-4 py-2 surface-50 border-bottom-1 surface-border text-sm">
                                <span class="font-medium text-600">
                                    Showing {{projectStaffList._filteredPositionsCount}} of {{projectStaffList._totalPositionsCount}}:
                                </span>
                                @if(getRoleFilter(projectStaffList._id).search){
                                    <p-chip [label]="'Search: ' + getRoleFilter(projectStaffList._id).search" [removable]="true"
                                        (onRemove)="removeSearchChip(projectStaffList._id)"></p-chip>
                                }
                                @if(getRoleFilter(projectStaffList._id).payRate != null){
                                    <p-chip
                                        [label]="'Pay rate: $' + getRoleFilter(projectStaffList._id).payRate + '/hr'"
                                        [removable]="true"
                                        (onRemove)="removePayRateChip(projectStaffList._id)">
                                    </p-chip>
                                }
                                @if(getRoleFilter(projectStaffList._id).minRating != null){
                                    <p-chip [label]="'Rating ≥ ' + getRoleFilter(projectStaffList._id).minRating + '★'" [removable]="true"
                                        (onRemove)="removeRatingChip(projectStaffList._id)"></p-chip>
                                }
                                @for(rank of getRoleFilter(projectStaffList._id).selectedRankings; track rank){
                                    <p-chip [label]="rank" [removable]="true"
                                        (onRemove)="removeRankingChip(projectStaffList._id, rank)">
                                    </p-chip>
                                }
                                @if(getRoleFilter(projectStaffList._id).favoriteOnly){
                                    <p-chip label="Favorites only" [removable]="true"
                                        (onRemove)="removeFavoriteChip(projectStaffList._id)"></p-chip>
                                }
                                @for(poolId of getRoleFilter(projectStaffList._id).selectedTalentPoolIds; track poolId){
                                    <p-chip [label]="'Pool: ' + getTalentPoolName(poolId)" [removable]="true"
                                        (onRemove)="removeTalentPoolChip(projectStaffList._id, poolId)">
                                    </p-chip>
                                }
                                <p-button label="Clear all" [link]="true" [text]="true" styleClass="p-0 text-sm"
                                    (click)="clearStaffFilter(projectStaffList._id)"></p-button>
                            </div>
                        }
                        <div class="inner-wrap surface-100 p-0">
                            <!-- Active Positions -->
                            @if(projectStaffList._activePositions?.length > 0) {
                                <staff-list-table
                                    [positions]="projectStaffList._activePositions"
                                    [projectStaffList]="projectStaffList"
                                    [projectDetails]="projectDetails"
                                    [user]="user"
                                    [emailType]="emailType"
                                    [isBackgroundCheckRequired]="isBackgroundCheckRequired"
                                    [secureBackgroundStatus]="secureBackgroundStatus"
                                    [showSorting]="true"
                                    [showRoleGroupChat]="true"
                                    [isActive]="true"
                                    [firmId]="firmId"
                                    [isPWCEnabled]="isPwcEnabled"
                                    [sectionTitle]="'Staffed'"
                                    [tableStyleClass]="'previously-assigned-table'"
                                    [selectable]="true"
                                    [selectedPositionIds]="selectedPositionIds()"
                                    (selectionChange)="onSelectionChange($event)"
                                    (sortPositions)="sortPositionsList($event.event, $event.projectStaffList, 'staffed')"
                                    (openReviewerDialog)="openReviewerDialog($event)"
                                    (openCreateChatReviewer)="openCreateChatReviewer($event)"
                                    (openRoleGroupChat)="openCreateChat(projectStaffList)"
                                    (showMailDialog)="showMailDialog($event.projectId, $event.emailType, $event.firm, $event.recipient, $event.roleId, $event.reviewerId)"
                                    (presumptiveApproveDeny)="presumptiveApproveDeny($event.event, $event.position, $event.roleType)"
                                    (openImmediateSendOfferModal)="openImmediateSendOfferModal($event.role, $event.reviewer)"
                                    (showFireReviewerDialog)="showFireReviewerDialog($event.event, $event.reviewerId, $event.positionId, $event.role, $event.firstName, $event.lastName)"
                                    (openReviewerDocumentDetail)="openReviewerDocumentDetail($event)"
                                ></staff-list-table>
                            }

                            <!-- Pending Approval Positions -->
                            @if(projectStaffList._pendingApprovalPositions?.length > 0) {
                                <staff-list-table
                                    [positions]="projectStaffList._pendingApprovalPositions"
                                    [projectStaffList]="projectStaffList"
                                    [projectDetails]="projectDetails"
                                    [user]="user"
                                    [emailType]="emailType"
                                    [showRoleGroupChat]="true"
                                    [isBackgroundCheckRequired]="isBackgroundCheckRequired"
                                    [secureBackgroundStatus]="secureBackgroundStatus"
                                    [sectionTitle]="'Pending Approval'"
                                    [showSorting]="true"
                                    [tableStyleClass]="'previously-assigned-table'"
                                    [selectable]="true"
                                    [selectedPositionIds]="selectedPositionIds()"
                                    (selectionChange)="onSelectionChange($event)"
                                    [firmId]="firmId"
                                    [isPWCEnabled]="isPwcEnabled"
                                    (sortPositions)="sortPositionsList($event.event, $event.projectStaffList, 'pendingApproval')"
                                    (openReviewerDialog)="openReviewerDialog($event)"
                                    (openCreateChatReviewer)="openCreateChatReviewer($event)"
                                    (openRoleGroupChat)="openCreateChatRolePresumptiveGroup(projectStaffList)"
                                    (presumptiveApproveDeny)="presumptiveApproveDeny($event.event, $event.position, $event.roleType)"
                                    (showMailDialog)="showMailDialog($event.projectId, $event.emailType, $event.firm, $event.recipient, $event.roleId, $event.reviewerId)"
                                    (openImmediateSendOfferModal)="openImmediateSendOfferModal($event.role, $event.reviewer)"
                                    (openReviewerDocumentDetail)="openReviewerDocumentDetail($event)"
                                ></staff-list-table>
                            }

                            <!-- Denied Positions -->
                            @if(projectStaffList._deniedPositions?.length > 0) {
                                <staff-list-table
                                    [positions]="projectStaffList._deniedPositions"
                                    [projectStaffList]="projectStaffList"
                                    [projectDetails]="projectDetails"
                                    [user]="user"
                                    [emailType]="emailType"
                                    [isBackgroundCheckRequired]="isBackgroundCheckRequired"
                                    [secureBackgroundStatus]="secureBackgroundStatus"
                                    [sectionTitle]="'Denied'"
                                    [showSorting]="true"
                                    [tableStyleClass]="'previously-assigned-table'"
                                    [firmId]="firmId"
                                    [isPWCEnabled]="isPwcEnabled"
                                    (sortPositions)="sortPositionsList($event.event, $event.projectStaffList, 'denied')"
                                    (openReviewerDialog)="openReviewerDialog($event)"
                                    (openCreateChatReviewer)="openCreateChatReviewer($event)"
                                    (showMailDialog)="showMailDialog($event.projectId, $event.emailType, $event.firm, $event.recipient, $event.roleId, $event.reviewerId)"
                                    (openImmediateSendOfferModal)="openImmediateSendOfferModal($event.role, $event.reviewer)"
                                    (openReviewerDocumentDetail)="openReviewerDocumentDetail($event)"
                                ></staff-list-table>
                            }

                            <!-- Previously Staffed Positions -->
                            @if(projectStaffList._previouslyAssignedPositions?.length > 0) {
                                <staff-list-table
                                    [positions]="projectStaffList._previouslyAssignedPositions"
                                    [projectStaffList]="projectStaffList"
                                    [projectDetails]="projectDetails"
                                    [user]="user"
                                    [emailType]="emailType"
                                    [isBackgroundCheckRequired]="isBackgroundCheckRequired"
                                    [secureBackgroundStatus]="secureBackgroundStatus"
                                    [sectionTitle]="'Previously Staffed'"
                                    [showSorting]="true"
                                    [tableStyleClass]="'previously-assigned-table'"
                                    [firmId]="firmId"
                                    [isPWCEnabled]="isPwcEnabled"
                                    (sortPositions)="sortPositionsList($event.event, $event.projectStaffList, 'previouslyAssigned')"
                                    (openReviewerDialog)="openReviewerDialog($event)"
                                    (openCreateChatReviewer)="openCreateChatReviewer($event)"
                                    (showMailDialog)="showMailDialog($event.projectId, $event.emailType, $event.firm, $event.recipient, $event.roleId, $event.reviewerId)"
                                    (openImmediateSendOfferModal)="openImmediateSendOfferModal($event.role, $event.reviewer)"
                                    (openReviewerDocumentDetail)="openReviewerDocumentDetail($event)"
                                ></staff-list-table>
                            }
                        </div>
                    </td>
                </tr>
            }
            @if(
                !(projectStaffList.positionsList && projectStaffList.positionsList.length > 0) &&
                !(projectStaffList.offerList && projectStaffList.offerList.length > 0)
            ){
                <tr>
                    <td colspan="7">
                        <span class="text-sm font-medium">There are no candidates staffed on this role</span>
                    </td>
                </tr>
            }
        </ng-template>
    </p-table>
}

@else {
    <span class="text-sm font-medium">{{'No Roles Created' | sentenceCase}}</span>
}

<p-dialog 
    [modal]="true" 
    draggable="false"
    [(visible)]="visibleDeleteModal" 
    [breakpoints]="{ '1199px': '75vw', '767px': '90vw' }" 
    [style]="{ width: '660px', height: selectedDeleteRole?.status === roleStatus.archive ? '50vh' : 'auto' }"  
    (onHide)="hideDeleteModal()">

    <ng-template pTemplate="header">
        <div class="inline-flex align-items-center justify-content-center gap-2">
            <span class="font-bold white-space-nowrap">
               Confirmation
            </span>
        </div>
    </ng-template>

    <div class="grid grid-nogutter">
        <div class="col-12 p-0 flex justify-content-between align-items-center">
            <p>  You are about to
                @if(selectedDeleteRole?.status === roleStatus.active){
                    end
                }@else {
                    restart
                }
                <span class="font-bold">{{selectedDeleteRole?.roleType}}</span>
                Role:
            </p>
          </div>
        @if(selectedDeleteRole?.status === roleStatus.active){
            <div class="col-12 p-0 flex justify-content-between align-items-center mt-2">
                <textarea placeholder="Message to be shared with staff on notification of role completion. (optional)" rows="3" [(ngModel)]="deleteRoleComment" pInputTextarea id="end-reason" class="flex-auto" autocomplete="off" cols="30" ></textarea>
            </div>
        }
        @if(isUnreadMessagesExist){
            <div class="col-12 p-0 flex justify-content-between align-items-center mt-2" ng-if="vm.discussions.length">
                <p class="font-twntwo">
                    <b>Note: </b> There are unread messages from one or more reviewer whose role is about to end.
                    These messages will not be readable if you continue. To read messages click “Cancel” and
                    navigate to the messaging screen.
                </p>
            </div>
        }
        @if(selectedDeleteRole?.status === roleStatus.archive){
            <p>
                Please select a new start date and time for the role.
            </p>
        <div class="col-12 p-0 flex justify-content-between align-items-center mt-2">
            <input type="text" style="display: none;" />
            <p-floatLabel>
                <p-calendar 
                    [(ngModel)]="restartDate"
                    inputId="restart_date" 
                    [minDate]="roleMinDate"
                    [maxDate]="roleMaxDate"
                    placeholder="mm/dd/yy"/>
                <label for="restart_date">{{'Start Date' | sentenceCase}}</label>
            </p-floatLabel>
        </div>
       
        <div class="col-12 p-0 flex justify-content-between align-items-center mt-2">
            <p-calendar 
            inputId="calendar-timeonly" 
            [(ngModel)]="restartTime"
            [timeOnly]="true" 
            hourFormat="12"
            styleClass="slider-style"
            />
        </div>
    }
    </div>

    <ng-template pTemplate="footer">
        <p-button label="cancel" size="large" [rounded]="true" (onClick)="hideDeleteModal()"/>
        <p-button label="ok" size="large" [rounded]="true" (onClick)="deleteRole()"/>
    </ng-template>
</p-dialog>

<!-- Staff filter overlay panel (shared, controlled via currentRoleId) -->
<p-overlayPanel #staffFilterPanel [style]="{'width': '320px'}" styleClass="staff-filter-panel">
    <div class="flex flex-column gap-3 p-2">
        <div class="font-semibold text-base border-bottom-1 surface-border pb-2">Filter Staff</div>

        <!-- Search -->
        <div class="flex flex-column gap-1">
            <label class="text-xs text-600 font-medium" [ngClass]="{'uppercase': helperService.getEnvironmentName() !== 'pwc'}">Search</label>
            <p-iconField iconPosition="left">
                <p-inputIcon styleClass="pi pi-search"></p-inputIcon>
                <input pInputText [(ngModel)]="pendingFilter.search" placeholder="Search by name" class="w-full" />
            </p-iconField>
        </div>

        <!-- Pay rate -->
        <div class="flex flex-column gap-1">
            <label class="text-xs text-600 font-medium" [ngClass]="{'uppercase': helperService.getEnvironmentName() !== 'pwc'}">Pay rate ($/hr)</label>
            <p-inputNumber [(ngModel)]="pendingFilter.payRate" placeholder="e.g. 26" [min]="0" styleClass="w-full" inputStyleClass="w-full" [showButtons]="false"></p-inputNumber>
        </div>

        <!-- Star rating -->
        <div class="flex flex-column gap-1">
            <label class="text-xs text-600 font-medium" [ngClass]="{'uppercase': helperService.getEnvironmentName() !== 'pwc'}">Minimum star rating</label>
            <p-rating [(ngModel)]="pendingFilter.minRating" [cancel]="true"></p-rating>
        </div>

        <!-- Ranking (PWC only) -->
        @if(isPwcEnabled){
            <div class="flex flex-column gap-1">
                <label class="text-xs text-600 font-medium" [ngClass]="{'uppercase': helperService.getEnvironmentName() !== 'pwc'}">Ranking</label>
                <p-multiSelect
                    [options]="rankingOptions"
                    optionLabel="label"
                    optionValue="value"
                    [(ngModel)]="pendingFilter.selectedRankings"
                    placeholder="Select rankings"
                    styleClass="w-full">
                </p-multiSelect>
            </div>
        }

        <!-- Favorite toggle -->
        <div class="flex align-items-center gap-2">
            <p-checkbox [(ngModel)]="pendingFilter.favoriteOnly" [binary]="true" inputId="filterFavorite"></p-checkbox>
            <label for="filterFavorite" class="cursor-pointer">Favorites only</label>
        </div>

        <!-- Talent pool -->
        @if(talentPools.length){
            <div class="flex flex-column gap-1">
                <label class="text-xs text-600 font-medium" [ngClass]="{'uppercase': helperService.getEnvironmentName() !== 'pwc'}">Talent pool</label>
                <p-multiSelect
                    [options]="talentPools"
                    optionLabel="name"
                    optionValue="_id"
                    [(ngModel)]="pendingFilter.selectedTalentPoolIds"
                    placeholder="Select pools"
                    styleClass="w-full">
                </p-multiSelect>
            </div>
        }

        <!-- Actions -->
        <div class="flex justify-content-between pt-1 border-top-1 surface-border">
            <p-button label="Clear" [link]="true" [text]="true" styleClass="p-0"
                (click)="pendingFilter = getDefaultFilter(); applyStaffFilter()"></p-button>
            <p-button label="Apply" [rounded]="true" size="small"
                (click)="applyStaffFilter()"></p-button>
        </div>
    </div>
</p-overlayPanel>

<!-- MP-5691: bulk action bar (Option B) — hidden at zero selection -->
<app-staff-bulk-action-bar
    [selectedPositions]="selectedPositions()"
    [isPWCEnabled]="isPwcEnabled"
    (action)="onBulkAction($event)"
    (clearSelection)="clearSelection()"
></app-staff-bulk-action-bar>
